const getDefaultState = () => {
	return {
		banner_form: {
			title: null,
			image: null,
		},
		province_options: [],
		regency_options: [],
		district_options: [],
	}
}

const default_state = getDefaultState()

export { default_state }